import { useEffect, useState } from "react";
import { AppError } from "../../../../stores/models/errors/AppError";
import { IOrganizationSecondaryDetailsFormValues } from "../../../authentication/_interfaces/IOrganizationSecondaryDetailsFormValues";
import { IOrganizationSignUpFlowValues } from "../_interfaces/IOrganizationSignUpFlowValues";
import { SecondaryOrganizationDetailsStepValues } from "../_interfaces/IOrganizationSignUpStepTypeValues";
import { OrganizationSecondaryDetailsValidation } from "../validation/OrganizationSecondaryDetailsValidation";

export function useSecondaryOrganizationDetailsController(
    values: SecondaryOrganizationDetailsStepValues,
    allValues: IOrganizationSignUpFlowValues,
    update: (patch: Partial<SecondaryOrganizationDetailsStepValues>) => void,
    onSuccess: (override?: Partial<SecondaryOrganizationDetailsStepValues>) => void
): {
    values: IOrganizationSecondaryDetailsFormValues,
    onChange: (patch: Partial<IOrganizationSecondaryDetailsFormValues>) => void,
    onSubmit: (override?: Partial<SecondaryOrganizationDetailsStepValues>) => void,
    isSubmitting: boolean,
    error: string | undefined,
    fieldErrors: Partial<Record<keyof IOrganizationSecondaryDetailsFormValues, string>>
} {
    const [error, setError] = useState<string>();
    const [fieldErrors, setFieldErrors] = useState<Partial<Record<keyof IOrganizationSecondaryDetailsFormValues, string>>>({});
    const [isSubmitting, setSubmitting] = useState(false);
    const [validationRun, setValidationRun] = useState(false);

    useEffect(() => {
        update({ backClicked: false })
    }, [])

    useEffect(() => {
        if (validationRun) {
            const errors = validate().errors;
            setFieldErrors(errors);
        }
    }, [values.mission, values.description, values.website, validationRun])


    const validate = (override?: Partial<SecondaryOrganizationDetailsStepValues>) => {
        return OrganizationSecondaryDetailsValidation({ ...values, ...override });
    }

    const isValidSubmission = (override?: Partial<SecondaryOrganizationDetailsStepValues>) => {
        return validate(override).valid;
    }

    const submit = async (override?: Partial<SecondaryOrganizationDetailsStepValues>) => {
        setSubmitting(true);
        setError(undefined);
        setValidationRun(true);

        try {
            const shouldSwitchStepsWithoutValidation = values.backClicked || override?.backClicked;
            if (shouldSwitchStepsWithoutValidation) { // If the flow should move to a different step
                update({ ...override });
                onSuccess(override);
            } else if (isValidSubmission(override)) {
                update({ ...override });
                onSuccess(override);
            }
        } catch (err) {
            if (err instanceof AppError) {
                switch (err.code) {
                    default:
                        setError(err.message);
                }
            } else {
                setError("An unknown error occurred.");
            }
        } finally {
            setSubmitting(false);
        }
    };

    return {
        values,
        onChange: update,
        onSubmit: submit,
        isSubmitting,
        error,
        fieldErrors
    };
}